import isEmpty from 'lodash/isEmpty.js';
import type { CiaDependencies } from '~/composables/useCia/types';
import { BLOOMREACH_COOKIE } from '~~/constants/bloomreach';
import { getFirstCookieValue } from '~~/helpers/cookies/getFirstCookieValue';
import { Logger } from '~~/helpers/logger';

export interface ViewCategoryProps {
  category_listed_products?: Array<string>;
}

type ViewCategoryParams = {
  slug: string;
  listedProducts: Array<string>;
  additionalProps?: ViewCategoryProps;
  email?: string;
  userId?: string;
};

type ViewCategoryRequest = {
  locale: string;
  slug: string;
  cookie?: string;
  email?: string;
  user_id?: string;
  additional_props?: ViewCategoryProps;
};

export default (dependencies: CiaDependencies) => {

  const { fetch, cookies, languageAndCountry } = dependencies;

  return async ({
    slug,
    listedProducts,
    additionalProps,
    email,
    userId,
  }: ViewCategoryParams): Promise<unknown> => {

    if (import.meta.server) {

      if (import.meta.dev) {

        Logger.debug('cia|viewCategory SSR suppressed');
      
      }

      return Promise.resolve();
    
    }

    if (!slug) {

      return Promise.resolve();
    
    }

    const bloomreachCookieValue = getFirstCookieValue(cookies?.get(BLOOMREACH_COOKIE));

    const payload: ViewCategoryRequest = {
      locale: languageAndCountry,
      slug,
      cookie: bloomreachCookieValue,
      additional_props: {
        category_listed_products: listedProducts,
      },
    };

    if (email) {

      payload.email = email;
    
    }

    if (userId) {

      payload.user_id = userId;
    
    }

    if (!isEmpty(additionalProps)) {

      payload.additional_props = {
        ...payload.additional_props,
        ...additionalProps,
      };
    
    }

    return fetch('/cia/view-category', {
      method: 'POST',
      body: payload,
    });
  
  };

};
